import React from 'react';
import cl from './Cokie.module.css';

const Cokie = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Politique relative aux cookies pour {props.shopName}</h1>

      <p>
      Ceci est la politique relative aux cookies pour {props.shopName}, accessible from{' '}
        {props.domain}.com
      </p>

      <p>
        <strong>Que sont les cookies</strong>
      </p>

      <p>
      Comme c'est la pratique courante avec presque tous les sites Web professionnels, ce site
         utilise des cookies, qui sont de minuscules fichiers qui sont téléchargés sur votre ordinateur,
         pour améliorer votre expérience. Cette page décrit les informations qu'ils
         recueillir, comment nous les utilisons et pourquoi nous avons parfois besoin de stocker ces cookies.
         Nous partagerons également comment vous pouvez empêcher le stockage de ces cookies
         cependant cela peut dégrader ou " casser " certains éléments des sites
         Fonctionnalité.
      </p>

      <p>
        <strong>Comment nous utilisons les cookies</strong>
      </p>

      <p>
      Nous utilisons des cookies pour diverses raisons détaillées ci-dessous. Malheureusement dans
         la plupart des cas, il n'y a pas d'options standard de l'industrie pour désactiver les cookies
         sans désactiver complètement les fonctionnalités et fonctionnalités qu'ils ajoutent à
         ce site. Il est recommandé de laisser sur tous les cookies si vous êtes
         vous ne savez pas si vous en avez besoin ou non au cas où ils sont utilisés pour fournir un
         service que vous utilisez.
      </p>

      <p>
        <strong>Désactivation des cookies</strong>
      </p>

      <p>
      Vous pouvez empêcher l'installation de cookies en ajustant les paramètres de votre
         navigateur (consultez l'aide de votre navigateur pour savoir comment procéder). Soit conscient que
         la désactivation des cookies affectera la fonctionnalité de ceci et de bien d'autres
         sites Web que vous visitez. La désactivation des cookies entraînera généralement également
         désactiver certaines fonctionnalités et caractéristiques de ce site. Donc
         il est recommandé de ne pas désactiver les cookies.
      </p>
      <p>
        <strong>Les cookies que nous installons</strong>
      </p>

      <ul>
        <li>
          <p>Commandes traitant les cookies associés</p>
          <p>
          Ce site propose des facilités de commerce électronique ou de paiement et certains cookies
             sont essentiels pour s'assurer que votre commande est mémorisée entre les pages
             afin que nous puissions le traiter correctement.
          </p>
        </li>

        <li>
          <p>Cookies liés aux sondages</p>
          <p>
          De temps à autre, nous proposons des enquêtes et des questionnaires aux utilisateurs pour
             vous fournir des informations intéressantes, des outils utiles ou pour
             mieux comprendre notre base d'utilisateurs. Ces enquêtes peuvent utiliser
             des cookies pour se rappeler qui a déjà participé à une enquête ou pour
             vous fournir des résultats précis après avoir changé de page.
          </p>
        </li>

        <li>
          <p>Cookies liés aux formulaires</p>
          <p>
          Lorsque vous soumettez des données à via un formulaire tel que ceux trouvés sur
             des pages de contact ou des formulaires de commentaires des cookies peuvent être configurés pour mémoriser votre
             détails de l'utilisateur pour la correspondance future.
          </p>
        </li>

        <li>
          <p>Cookies de préférences du site</p>
          <p>
          Afin de vous offrir une excellente expérience sur ce site, nous
             fournir la fonctionnalité pour définir vos préférences sur la façon dont ce site
             fonctionne lorsque vous l'utilisez. Afin de mémoriser vos préférences, nous avons besoin
             pour définir des cookies afin que ces informations puissent être appelées chaque fois que vous
             interagir avec une page est affecté par vos préférences.
          </p>
        </li>
      </ul>

      <p>
        <strong>Cookies tiers</strong>
      </p>

      <p>
      Dans certains cas particuliers, nous utilisons également des cookies fournis par des tiers de confiance
         des soirées. La section suivante détaille les cookies tiers que vous
         pourraient rencontrer via ce site.
      </p>

      <ul>
        <li>
          <p>
          De temps en temps, nous testons de nouvelles fonctionnalités et apportons des modifications subtiles à
             la façon dont le site est livré. Quand nous testons encore de nouveaux
             fonctionnalités, ces cookies peuvent être utilisés pour garantir que vous recevez un
             une expérience cohérente sur le site tout en veillant à ce que nous
             comprendre quelles optimisations nos utilisateurs apprécient le plus.
          </p>
        </li>

        <li>
          <p>
          Comme nous vendons des produits, il est important pour nous de comprendre les statistiques
             sur le nombre de visiteurs de notre site qui effectuent réellement un achat
             et en tant que tel, c'est le type de données que ces cookies suivront.
             Ceci est important pour vous car cela signifie que nous pouvons faire avec précision
             prévisions commerciales qui nous permettent de surveiller nos publicités et
             coûts des produits pour assurer le meilleur prix possible.
          </p>
        </li>
      </ul>

      <p>
        <strong>Plus d'information</strong>
      </p>

      <p>
      J'espère que cela a clarifié les choses pour vous et comme c'était le cas auparavant
         mentionné s'il y a quelque chose dont vous n'êtes pas sûr d'avoir besoin ou
         il n'est généralement pas plus sûr de laisser les cookies activés au cas où ils interagissent
         avec l'une des fonctionnalités que vous utilisez sur notre site.
      </p>

      <p>
      Pour plus d'informations générales sur les cookies, veuillez lire{' '}
         <a href="https://www.cookiepolicygenerator.com/sample-cookies-policy/">
           l'article Politique de Cookies
        </a>
        .
      </p>

      <p>
      Cependant, si vous cherchez encore plus d'informations, vous pouvez
         contactez-nous via l'une de nos méthodes de contact préférées :
      </p>

      <ul>
        <li>Email: soutien@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Cokie;
